import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_API_URL?.replace('/api/v1', '') || 'http://localhost:5000';

let socket = null;

export const connectSocket = (token) => {
  if (socket?.connected) {
    // Update auth token on existing socket for reconnections
    socket.auth = { token };
    return socket;
  }

  if (socket) {
    socket.disconnect();
  }

  socket = io(SOCKET_URL, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 3000,
  });

  socket.on('connect', () => {
    console.log('Socket connected');
    // Re-join user room and chat rooms after reconnect
    if (socket._onReconnect) {
      socket._onReconnect();
    }
  });

  socket.on('connect_error', (err) => {
    console.error('Socket connection error:', err.message);
    // If token is invalid, try refreshing from localStorage
    if (err.message === 'Invalid token' || err.message === 'jwt expired') {
      const freshToken = localStorage.getItem('accessToken');
      if (freshToken && socket.auth.token !== freshToken) {
        socket.auth = { token: freshToken };
      }
    }
  });

  return socket;
};

export const reconnectSocket = () => {
  const token = localStorage.getItem('accessToken');
  if (!token) return;

  if (socket) {
    socket.auth = { token };
    if (!socket.connected) {
      socket.connect();
    }
  } else {
    connectSocket(token);
  }
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const getSocket = () => socket;
